import { Link } from 'react-router-dom';
import { Instagram, Twitter, Youtube, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_popcult-bazaar/artifacts/aozrkof5_Collect-I-con%20logo%20black-01.jpg" 
              alt="CollectrsInc" 
              className="h-16 w-16 rounded-full"
              data-testid="footer-logo"
            />
            <p className="text-sm text-gray-400">
              India's premier destination for pop culture collectibles. Marvel, DC, Anime & more.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 accent-red">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/shop" className="hover:text-red-500 transition" data-testid="footer-shop">Shop</Link></li>
              <li><Link to="/auctions" className="hover:text-red-500 transition" data-testid="footer-auctions">Auctions</Link></li>
              <li><Link to="/community" className="hover:text-red-500 transition" data-testid="footer-community">Community</Link></li>
              <li><Link to="/collections" className="hover:text-red-500 transition" data-testid="footer-collections">Collections</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold text-lg mb-4 accent-red">Categories</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/shop?category=Marvel" className="hover:text-red-500 transition" data-testid="footer-marvel">Marvel</Link></li>
              <li><Link to="/shop?category=DC" className="hover:text-red-500 transition" data-testid="footer-dc">DC Comics</Link></li>
              <li><Link to="/shop?category=Anime" className="hover:text-red-500 transition" data-testid="footer-anime">Anime</Link></li>
              <li><Link to="/shop?type=Action Figure" className="hover:text-red-500 transition" data-testid="footer-action-figures">Action Figures</Link></li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-semibold text-lg mb-4 accent-red">Connect With Us</h4>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="hover:text-red-500 transition" data-testid="social-instagram"><Instagram size={20} /></a>
              <a href="#" className="hover:text-red-500 transition" data-testid="social-twitter"><Twitter size={20} /></a>
              <a href="#" className="hover:text-red-500 transition" data-testid="social-youtube"><Youtube size={20} /></a>
              <a href="#" className="hover:text-red-500 transition" data-testid="social-email"><Mail size={20} /></a>
            </div>
            <p className="text-sm text-gray-400">Join our community of passionate collectors!</p>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center text-sm text-gray-400">
          <p data-testid="footer-copyright">&copy; 2025 CollectrsInc. All rights reserved. Built with passion for collectors across India.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;